<template>
  <!-- 线路调整 (这个页面没用上) -->
  <div>
    <div class="glo_Table">
      <!-- 预览详情 -->
      <div class="detailsBox">
        <div class="item">
          <div class="dItemLabel">发车批次号:</div>
          <div class="dItemVal">pc0000001</div>
        </div>
        <div class="item">
          <div class="dItemLabel">车型:</div>
          <div class="dItemVal">4.2m车</div>
          <div class="ditemBtn">更换</div>
        </div>
        <div class="item">
          <div class="dItemLabel">最大载重:</div>
          <div class="dItemVal">10吨</div>
        </div>
        <div class="item">
          <div class="dItemLabel">最大体积:</div>
          <div class="dItemVal">10吨</div>
        </div>
        <div class="item">
          <div class="dItemLabel">车牌号:</div>
          <div class="dItemVal">qb6666</div>
        </div>
        <div class="item">
          <div class="dItemLabel">司机:</div>
          <div class="dItemVal">大风歌手打</div>
        </div>
        <div class="item">
          <div class="dItemLabel">押运员:</div>
          <div class="dItemVal">大哥哥</div>
        </div>
        <div class="item">
          <div class="dItemLabel">途径站点:</div>
          <div class="dItemVal" style="color: #f00">24个</div>
        </div>
      </div>
      <el-table
        :height="tableHeigth4"
        header-align="center"
        ref="mytable4"
        :data="tableData4"
        border
        stripe
        @selection-change="handleSelectionChange4"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <!-- <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column> -->
        <template v-for="(item, index) in myTableHeard4">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'memberNickname' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel" @click.stop="goYdDetails(scope.row)">
                {{ scope.row.memberNickname }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="280px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                class="rbtns"
                v-if="scope.$index > 0"
                @click.stop="moveUp(scope.$index)"
                >上移</el-button
              >
              <el-button
                v-if="scope.$index !== tableData4.length - 1"
                class="rbtns"
                @click.stop="moveDown(scope.$index)"
                >下移</el-button
              >
              <el-button
                v-if="scope.$index > 0"
                class="rbtns"
                @click.stop="moveTop(scope.$index)"
                >置顶</el-button
              >
              <el-button
                v-if="scope.$index !== tableData4.length - 1"
                class="rbtns"
                @click.stop="moveBottom(scope.$index)"
                >置底</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                    class="rbtns"
                    @command="handleCommandBtns($event, scope.row)"
                  >
                    <el-button type="primary">
                      更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="a">调整线路</el-dropdown-item>
                      <el-dropdown-item command="b">出车确认</el-dropdown-item>
                      <el-dropdown-item command="c">车费分摊</el-dropdown-item>
                      <el-dropdown-item command="d">提成分摊</el-dropdown-item>
                      <el-dropdown-item command="d">出车完成</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableHeigth4: "81vh", //第四步表格高度
      myTableHeard4: [
        {
          name: "任务编号",
          field: "memberNickname",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "会员号",
          field: "memberId",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "会员号",
          field: "memberId",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "会员号",
          field: "memberId",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      tableData4: [
        {
          name: "测试",
          memberNickname: 23432434,
          memberId: "memberId",
        },
        {
          name: "1233333",
          memberNickname: 123,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 234,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
      ], //
      selectTableData4: [],
    };
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    // 表格选择事件(第四步)
    handleSelectionChange4(e) {
      this.selectTableData4 = e;
    },
  },
};
</script>
<style scoped lang='less'>
.detailsBox {
  display: flex;
  flex-wrap: wrap;
  background-color: #f2f2f2;
  padding: 10px 10px 0;
  font-size: 16px;
  margin-bottom: 20px;

  .item {
    display: flex;
    margin-right: 40px;
    min-width: 180px;
    margin-bottom: 10px;

    .dItemLabel {
      margin-right: 10px;
    }
    .ditemBtn {
      color: #0000ff;
      margin-left: 20px;
    }
  }
}
</style>